<template>
  <div>
    <div class="d-flex align-center justify-space-between">
      <h1 class="py-0">Customers</h1>
      <v-btn color="primary" @click="$router.push({ name: 'website.customer.create' })">
        <v-icon>mdi-plus</v-icon> Add customer
      </v-btn>
    </div>
    <v-card class="pa-3">
      <Resource
        :document="document"
        :filter-fields="null"
        :filter-data="filterData"
        :filter-callback="setFilterData"
        :searchable="searchableField"
        :columns="columns"
        :update-router-callback="getUpdateRouterData"
        :routeName="updateRouteName"
      />
      <div class="d-flex justify-space-between">
        <limit-page :callback="setLimit" />
        <pagination :visible="0" :length="1000000" :page.sync="page"></pagination>
      </div>
    </v-card>
  </div>
</template>
<script>
import Resource from '@/components/Resources';
import resourceListMixin from '@/mixins/resource-list';

export default {
  components: { Resource },
  mixins: [resourceListMixin],
  data() {
    return {
      resourceType: 'customer',
      columns: {
        // Selectable: {
        //   blankLabel: true,
        //   kind: 'selectable',
        //   width: 1,
        // },
        Email: {
          field: 'email',
          kind: 'text',
        },
        Address: {
          field: 'address1',
          kind: 'text',
        },
        Order: {
          field: 'totalOrder',
          kind: 'text',
        },
        Spend: {
          field: 'totalPayment',
          kind: 'text',
        },
        // Actions: {
        //   kind: 'actions',
        // },
      },
      updateRouteName: 'website.customer.update',
      searchableField: 'title_search',
      sortable: [],
    };
  },
};
</script>
